export class LongtextToggle extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.initialise()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.initialise.bind(this))

    this.listeners.add(
      this.els.button.element,
      'click',
      this.buttonClickEvent.bind(this),
    )
  }

  initialise () {
    const containerHeight =
      this.els?.buttonContainer?.element.offsetHeight +
      this.els?.container?.element.offsetHeight

    this.externalEls?.listContainer?.element.style.setProperty(
      '--Container_Height',
      `${containerHeight}px`,
    )
  }

  buttonClickEvent (e) {
    e.preventDefault()

    this.externalEls?.listContainer?.element.classList.toggle(
      'prd-List_Item-longCopy-open',
    )

    // Change button link
    this.els?.buttonText?.elements?.forEach(item => {
      item.setAttribute(
        'aria-hidden',
        item.getAttribute('aria-hidden') !== 'true',
      )
    })
  }
}

if (!customElements.get('longtext-toggle')) {
  customElements.define('longtext-toggle', LongtextToggle)
}
